export default {
  name: 'dashify:MultipleCounters',
  title: 'Multiple Counter',
  owner: 'System',
  solution: '',
  tags: ['widget', 'counter'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'div',
        { '.': 'grid gap-4 p-2' },
        [
          ['div', { '.': 'border border-rounded p-2' }, [['dashify:Counter', { count: 0 }]]],
          ['div', { '.': 'border p-2' }, [['dashify:Counter', { count: 10 }]]],
          ['div', { '.': 'border p-2' }, [['dashify:Counter', { count: 100 }]]],
        ],
      ],
    ],
  },
};
